import { render, staticRenderFns } from "./LiveAuctionDetailsPage.vue?vue&type=template&id=1dcb850e&scoped=true&"
import script from "./LiveAuctionDetailsPage.vue?vue&type=script&lang=js&"
export * from "./LiveAuctionDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./LiveAuctionDetailsPage.vue?vue&type=style&index=0&id=1dcb850e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcb850e",
  null
  
)

export default component.exports